import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { formatDate } from '@/utils/date';
import { fetchCreate, fetchDetail, fetchCustomerList } from '@/api/PMS/baseInformation/roomcustomer';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      outChecked: true,
      inChecked: false,
      loading: false,
      noEmigration: true,
      outDate: '',
      customerId: [],
      areaGroupId: '',
      userList: [],
      customerList: [],
      roomData: {},
      childData: {
        list: []
      }
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.outDate = formatDate(new Date(Date.now()), 'yyyy-MM-dd').toString();
      this.customerId = [];
      this.areaGroupId = '';
      this.outChecked = true;
      this.noEmigration = true;
      this.childData.list = [];
      this.customerList = [];
      this.roomData = [];

      if (this.keyValue > 0) {
        var queryData = {
          houseId: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          if (response.data.data !== null) {
            _this.roomData = response.data.data;
            _this.areaGroupId = response.data.data.areaGroupId;

            _this.remoteMethod();

            if (!response.data.data.customerName) {
              _this.noEmigration = false;
              _this.outChecked = false;
            }
          } else {
            _this.noEmigration = false;
            _this.outChecked = false;
          }
        });
      } else {
        this.roomData = {};
      }
    },
    remoteMethod: function remoteMethod() {
      var _this2 = this;

      var queryData = {
        areaGroupId: this.areaGroupId,
        customerName: ''
      };
      fetchCustomerList(queryData).then(function (r) {
        _this2.loading = false;
        _this2.customerList = r.data.data;
        _this2.userList = _this2.customerList.slice(0, 20);
      });
    },
    userFilter: function userFilter() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var arr = this.customerList.filter(function (item) {
        return item.customerName.includes(query);
      });

      if (arr.length > 20) {
        this.userList = arr.slice(0, 20);
      } else {
        this.userList = arr;
      }

      this.customerId = query;
    },
    handUpdate: function handUpdate() {
      var _this3 = this;

      if (this.keyValue > 0) {
        var data = JSON.parse(JSON.stringify(this.childData));

        if (this.outChecked) {
          var outObj = {
            customerId: this.roomData.customerId,
            houseId: this.keyValue,
            inOut: 1,
            outDate: this.outDate
          };
          data.list.push(outObj);
        }

        if (this.inChecked) {
          var inObj = {
            customerId: this.customerId,
            houseId: this.keyValue,
            inOut: 2,
            outDate: this.outDate
          };
          data.list.push(inObj);
        }

        if (this.inChecked && !this.customerId) {
          this.$message({
            message: '请输入新业主',
            type: 'error',
            duration: 3000
          });
          return false;
        }

        fetchCreate(data).then(function (res) {
          console.log(res);

          if (res.data.code === 200) {
            _this3.$emit('handCancle', 'offCustomer');

            _this3.Alert({
              alertType: 'update'
            });
          }
        });
      }
    },
    // 检查业主是否迁出,迁出后才能迁入
    checkOut: function checkOut() {
      if (this.noEmigration) {
        if (!this.outDate) {
          this.$message({
            message: '请先选择迁出日期',
            type: 'error',
            duration: 3000
          });
          return false;
        }
      }
    },
    handBindingCancle: function handBindingCancle() {
      this.$emit('handCancle', 'offCustomer');
    }
  }
};